<template>
  <div style="height: 138px;">
    <div class="header-container">
      <div class="header-content banxin">
        <div>
          <img src="@/assets/images/home/phone.svg" style="height: 12px; width: 12px;margin-right: 6px;" />全国服务热线：<span
            class="otherColor">187 0146 6986</span>
        </div>
        <div style="border-right:  1px solid #DEDEDE;padding-right: 20px;">热线服务时间：<span
            class="otherColor">9:00-20:00</span></div>
        
        <!-- 微信二维码 -->
        <div class="qr-container" @mouseenter="activeQr = 'wx'" @mouseleave="activeQr = null">
          <img src="@/assets/images/home/wxicon.svg" style="height: 11px; width: 13px;" />
          <div v-show="activeQr === 'wx'" class="qr-popup">
            <div class="qr-arrow"></div>
            <img src="@/assets/images/wecode.png" class="qr-image" />
            <!-- <p>微信扫码关注</p> -->
          </div>
        </div>
        
        <!-- 抖音二维码 -->
        <div class="qr-container" @mouseenter="activeQr = 'douyin'" @mouseleave="activeQr = null">
          <img src="@/assets/images/home/douyinicon.svg" style="height: 10px; width: 25px;" />
          <div v-show="activeQr === 'douyin'" class="qr-popup">
            <div class="qr-arrow"></div>
            <img src="@/assets/images/dyh.png" class="qr-image" />
            <!-- <p>抖音扫码关注</p> -->
          </div>
        </div>
        
        <!-- 小红书二维码 -->
        <div class="qr-container" @mouseenter="activeQr = 'xhs'" @mouseleave="activeQr = null">
          <img src="@/assets/images/home/xhsicon.svg" style="height: 8px; width: 22px;" />
          <div v-show="activeQr === 'xhs'" class="qr-popup">
            <div class="qr-arrow"></div>
            <img src="https://yobu-cloud.oss-cn-beijing.aliyuncs.com/p-img/%E5%BA%95%E9%83%A8%E5%B0%8F%E7%BA%A2%E4%B9%A6.png" class="qr-image" />
            <!-- <p>小红书扫码关注</p> -->
          </div>
        </div>
      </div>
      <div style="background-color: #FFFFFF;">
        <div class="header-menu banxin">
          <img src="@/assets/images/home/logo.svg" style="height: 46px; width: 151px;" />

          <div class="all-menus">
            <div v-for="(item, index) in menuList" :key="index">
              <div 
                :style="menuIndex === index ? activeStyle : inactiveStyle" 
                @click="handleMenuNav(item.path, index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header',
  data() {
    return {
      menuIndex: 0,
      activeQr: null, // 当前显示的二维码
      activeStyle: {
        'font-weight': '600',
        'color': '#FC5F10' // 激活状态颜色
      },
      inactiveStyle: {
        'font-weight': '400',
        'color': '#010101' // 默认颜色
      },
      menuList: [
        { name: "首页", path: "/" },
        { name: "关于呦步", path: "/about" },
        { name: "主营产品系列", path: "/products" },
        { name: "足踝健康科普", path: "/knowledge" },
        { name: "应用场景", path: "/scenarios" },
        { name: "一站式定制", path: "/customization" },
        { name: "新闻活动", path: "/news" },
        { name: "门店分布", path: "/stores" },
        { name: "加入呦步", path: "/join" }
      ]
    }
  },
  watch: {
    '$route'(to) {
      this.updateActiveMenu(to.path)
    }
  },
  created() {
    this.updateActiveMenu(this.$route.path)
  },
  methods: {
    handleMenuNav(url, index) {
      if (this.$route.path !== url) {
        this.$router.push(url)
      }
      this.menuIndex = index
      window.localStorage.setItem("menuIndex", index)
    },
    updateActiveMenu(currentPath) {
      // 优先检查完全匹配的路径
      const exactMatchIndex = this.menuList.findIndex(item => item.path === currentPath)
      if (exactMatchIndex !== -1) {
        this.menuIndex = exactMatchIndex
        return
      }
      
      // 如果没有完全匹配，检查包含关系（适用于子路由）
      const partialMatchIndex = this.menuList.findIndex(item => 
        currentPath.startsWith(item.path) && item.path !== '/'
      )
      if (partialMatchIndex !== -1) {
        this.menuIndex = partialMatchIndex
        return
      }
      
      // 如果都没有匹配，使用localStorage保存的值或默认0
      const savedIndex = parseInt(window.localStorage.getItem('menuIndex')) || 0
      this.menuIndex = savedIndex
    }
  }
}
</script>

<style scoped lang="scss">
.header-menu {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.all-menus {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  font-size: 20px;
  flex: 1;
  padding-left: 86px;
}

.all-menus>div {
  cursor: pointer;
  transition: all 0.3s;
}

.all-menus>div:hover {
  color: #FC5F10;
}

.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 38px;
  background: #F1F1F1;
  z-index: 1000;

}

.header-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  height: 100%;
  font-size: 14px;
  color: #333333;
}

.otherColor {
  color: #FC5F10;
}

/* 二维码相关样式 */
.qr-container {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.qr-popup {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 10px;
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  text-align: center;
}

.qr-arrow {
  position: absolute;
  top: -6px;
  right: 10px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  filter: drop-shadow(0 -2px 1px rgba(0, 0, 0, 0.1));
}

.qr-image {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto 5px;
  object-fit: cover;
}

.qr-popup p {
  margin: 0;
  font-size: 12px;
  color: #666;
}
</style>